import { nativeApplicationVersion } from 'expo-application';
import { Stack } from 'expo-router';
import { createdAt, updateId } from 'expo-updates';
import { DateTime } from 'luxon';
import Row from '@/components/UI/Row';
import Text from '@/components/UI/Text';

export default function ProfileAbout() {
  return (
    <>
      <Stack.Screen
        options={{
          title: 'About',
        }}
      />
      <Row spaced>
        <Text bold>Version</Text>
        <Text>{nativeApplicationVersion || 'Unknown'}</Text>
      </Row>
      <Row spaced>
        <Text bold>Version ID</Text>
        <Text>{updateId?.split('-')[0] || 'Unknown'}</Text>
      </Row>
      <Row spaced>
        <Text bold>Version Date/Time</Text>
        <Text>
          {createdAt
            ? DateTime.fromJSDate(createdAt).toLocaleString(
                DateTime.DATETIME_SHORT,
              )
            : 'Unknown'}
        </Text>
      </Row>
    </>
  );
}
